module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "sigrun-rossmanith.229061bb.jpg" + "?" + Date.now();